import type { CookieConsent } from '../types/cookieConsent';

const STORAGE_KEY = 'bindles_cookie_consent';
const CURRENT_VERSION = 1;

export function readConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'version' in parsed &&
      (parsed as CookieConsent).version === CURRENT_VERSION
    ) {
      return parsed as CookieConsent;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeConsent(consent: CookieConsent): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
}

export function clearConsent(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function buildConsent(analytics: boolean): CookieConsent {
  return {
    version: CURRENT_VERSION,
    timestamp: new Date().toISOString(),
    essential: true,
    analytics,
  };
}
